import React from "react";
import { PageClose } from "../studio/StudioPage";
export default function BlogCTA() {
  return <PageClose page="journal" />;
}
